import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  rightText: {
    float: "right",
  },
  paySpanIcon: {
    marginTop: 4,
    width: 18,
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
}));

export default useStyles;
